<template>
  <v-dialog v-model="dialog" max-width="900" persistent>
    <v-card>
      <v-toolbar color="#E3002C" dark dense>
        <v-toolbar-title>
          Actualización Datos de Entrega
          {{ object.order_backend_code }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card outlined style="border: 1px solid #1976d2;">
          <div bottom class="text-h6">Datos de Entrega</div>
          <v-row dense>
            <v-col>
              <v-textarea
                hide-details
                v-model="object.address"
                label="Domicilio"
                clearable
                rows="1"
                auto-grow
              />
            </v-col>
            <v-col>
              <v-text-field
                disabled
                hide-details
                :value="
                  object.postal_code
                    ? object.postal_code_code +
                      ' - ' +
                      object.postal_code_description
                    : ''
                "
                label="Código Postal"
              >
                <v-icon
                  slot="append-outer"
                  class="enabled-icon"
                  @click="postalCodeSearchClick"
                >
                  mdi-magnify
                </v-icon>
                <v-icon
                  slot="prepend"
                  :class="object.postal_code ? 'enabled-icon' : 'disabled-icon'"
                  @click="postalCodeSelected(null)"
                >
                  mdi-close
                </v-icon>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-text-field
                hide-details
                label="Nombre de Contacto"
                v-model="object.delivery_contact_name"
              />
            </v-col>
            <v-col>
              <v-text-field
                hide-details
                label="Teléfono de Contacto"
                v-model="object.delivery_contact_phone"
              />
            </v-col>
            <v-col>
              <v-menu
                ref="Hdelivery_date_from"
                v-model="object.show_picker_from"
                :close-on-content-click="false"
                :return-value.sync="object.delivery_date_from"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    hide-details="true"
                    label="Fecha Desde"
                    v-model="object.delivery_date_from_formatted"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="object.delivery_date_from"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="object.show_picker_from = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="HeaderDeliveryDateFromEntered()"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu
                ref="Hdelivery_date_to"
                v-model="object.show_picker_to"
                :close-on-content-click="false"
                :return-value.sync="object.delivery_date_to"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    label="Fecha Hasta"
                    hide-details
                    v-model="object.delivery_date_to_formatted"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="object.delivery_date_to"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="object.show_picker_to = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="HeaderDeliveryDateToEntered()"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-textarea
                hide-details
                v-model="object.internal_comments"
                label="Comentarios Internos"
                clearable
                rows="2"
                auto-grow
              />
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="warning" :disabled="loading" @click="cancel"
          >Cancelar</v-btn
        >
        <v-btn color="success" :loading="loading" @click="save">Guardar</v-btn>
      </v-card-actions>
    </v-card>
    <paginated-search-dialog
      :show="OrderDeliveryShowSearch"
      :title="OrderDeliverySearchOptions.title"
      :endpoint="OrderDeliverySearchOptions.endpoint"
      :ordering="OrderDeliverySearchOptions.ordeting"
      :searchLabel="OrderDeliverySearchOptions.searchLabel"
      :headers="OrderDeliverySearchOptions.headers"
      :filterString="OrderDeliverySearchOptions.filterString"
      :canEdit="false"
      :canAdd="false"
      :searchOnURL="OrderDeliverySearchOptions.searchOnURL"
      @itemSelected="searchSelected($event)"
      @cancel="searchCanceled"
    />
  </v-dialog>
</template>

<script>
import DataOrder from "@/components/clon/DataOrder.js";
import PaginatedSearchDialog from "@/components/PaginatedSearchDialog.vue";

export default {
  name: "OrderDeliveryUpdate",

  components: {
    PaginatedSearchDialog
  },

  props: {
    show: Boolean,
    orderId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      dialog: false,
      loading: false,
      order: new DataOrder(this.$bRoot),
      object: null,
      OrderDeliveryShowSearch: false,
      OrderDeliverySearchOptions: {}
    };
  },

  watch: {
    show: {
      immediate: true,
      async handler(value) {
        this.dialog = value;
        if (value) {
          await this.load();
        }
      }
    },
    dialog(value) {
      if (!value && this.show) {
        this.$emit("cancel");
      }
    },
    orderId: {
      async handler() {
        if (this.show) {
          await this.load();
        }
      }
    }
  },

  methods: {
    async load() {
      if (!this.orderId) {
        return;
      }
      try {
        this.loading = true;
        let data = await this.order.getDeliveryUpdate(this.orderId);
        this.object = { ...data };
      } catch (error) {
        this.$bRoot.setError(error);
      } finally {
        this.loading = false;
      }
    },

    postalCodeSearchClick() {
      this.OrderDeliverySearchOptions = {
        headers: [
          { text: "Código", value: "code", sortable: false },
          { text: "Descripción", value: "description", sortable: false }
        ],
        title: "Domicilio de Entrega, Código Postal...",
        endpoint: "/data/postal_codes",
        ordering: "code",
        searchLabel: "Código/Descripción",
        filterString: null,
        selected: "postalCodeSelected",
        searchOnURL: false
      };
      this.OrderDeliveryShowSearch = true;
    },

    async postalCodeSelected(postalCode) {
      this.object = await this.order.setPostalCode(this.object, postalCode);
    },

    searchSelected(data) {
      this[this.OrderDeliverySearchOptions.selected](data);
      this.searchCanceled();
    },

    searchCanceled() {
      this.OrderDeliveryShowSearch = false;
      this.OrderDeliverySearchOptions = {};
    },

    async HeaderDeliveryDateFromEntered() {
      this.$refs["Hdelivery_date_from"].save(this.object.delivery_date_from);
      let res = await this.order.deliveryUpdateDateFromChange(this.object);
      this.object = res.order;
      if (!this.$bRoot.isNullOrEmpty(res, "error")) {
        this.$bRoot.setError(res.error);
      }
    },

    async HeaderDeliveryDateToEntered() {
      this.$refs["Hdelivery_date_to"].save(this.object.delivery_date_to);
      let res = await this.order.deliveryUpdateDateToChange(this.object);
      this.object = res.order;
      if (!this.$bRoot.isNullOrEmpty(res, "error")) {
        this.$bRoot.setError(res.error);
      }
    },

    async save() {
      let saved = null;
      try {
        this.loading = true;
        let res = await this.order.deliveryUpdateDateToChange(this.object);
        this.object = res.order;
        if (!this.$bRoot.isNullOrEmpty(res, "error")) {
          throw res.error;
        }
        saved = await this.order.saveDeliveryUpdate(this.object);
      } catch (error) {
        this.$bRoot.setError(error.message ? error.message : error);
      } finally {
        this.loading = false;
        if (saved) {
          this.dialog = false;
          this.$emit("saved", saved);
        }
      }
    },

    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    }
  }
};
</script>
